import { findIndex } from 'lodash'
import Software from './Software'

export default class AttributeType {
  constructor(attributeType = {}) {
    this.id = attributeType.id || null
    this.title = attributeType.title || ''
    this.type = attributeType.type || ''
    this.description = attributeType.description || ''
    this.scraper_payload = attributeType.scraper_payload || ''
    this.raw_scrape_type = attributeType.raw_scrape_type || ''
    this.cast_type = attributeType.cast_type || ''
    this.scrapes_on_client = attributeType.scrapes_on_client || false
    this.software = attributeType.software || new Software
    this.can_be_vulnerable = attributeType.can_be_vulnerable || false
    this.published = attributeType.published || false
    this.before_parser = attributeType.before_parser || null
    this.secondary_scrapers = attributeType.secondary_scrapers || []
    this.assessors = attributeType.assessors || []
    this.scrapers = attributeType.scrapers || []
    this.scraper_count = attributeType.scraper_count || 0
  }

  static mutations() {
    return {
      setAttributeType: (state, attributeType) => state.attributeType = new AttributeType(attributeType),
      clearAttributeType: (state) => state.attributeType = new AttributeType,
      updateTitle: (state, title) => state.attributeType.title = title,
      updateType: (state, type) => state.attributeType.type = type,
      updateHandler: (state, handler) => state.attributeType.handler = handler,
      updateDescription: (state, description) => state.attributeType.description = description,
      updateDefaultValue: (state, default_value) => state.attributeType.default_value = default_value,
      updateSoftwareId: (state, id) => state.attributeType.software.id = id,
      toggleCanBeVulnerable: (state) => state.attributeType.can_be_vulnerable = !state.attributeType.can_be_vulnerable,
      toggleClientScrape: (state) => state.attributeType.scrapes_on_client = !state.attributeType.scrapes_on_client,
      updateCastTo: (state, payload) => state.attributeType.cast_type = payload,
      updateBeforeParser: (state, payload) => state.attributeType.before_parser = payload,
      togglePublished: (state) => state.attributeType.published = !state.attributeType.published,
      removeScraper: (state, scraperId) => {
        const index = findIndex(state.attributeType.scrapers, scraper => scraper.id === scraperId)
        state.attributeType.scrapers.splice(index, 1)
      }
    }
  }
}